var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandslide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fit: "",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.513 2.006c.505.014.886.049 1.146.105l1.43.265 1.196.775c.329 2.464-.084 3.927.538 5.72.064.187.404.682 1.018 1.485a.3.3 0 0 1 .062.167l.058 1.095a.5.5 0 0 0 .25.406l4.105 2.371.01.006 1.839 1.117a1 1 0 0 1 .304.287l.937 1.359a.5.5 0 0 1 .032.054l.508.984a.5.5 0 0 0 .033.054l1.029 1.492a.5.5 0 0 0 .064.076l1.963 1.899c.072.07.12.162.17.256l-.002-.007.047.028H2V2.493a.5.5 0 0 1 .513-.487zM19.12 13.191c1.02-.346 1.39-.252 2.085.528.272.31.601 1.128.988 2.453a.5.5 0 0 1-.031.362l-.855 1.73a.5.5 0 0 1-.325.264l-1.553.394a.5.5 0 0 1-.5-.158 7.374 7.374 0 0 0-.85-.82c-.618-.56-1.03-1.02-1.044-1.056-.147-.448.194-1.333.522-2.112.198-.483.494-.954.888-1.411a.5.5 0 0 1 .379-.174zm-7.03-4.177c.525-.104 1.32.391 1.388.37l.132.015a.825.825 0 0 1 1.044.543c.16.462.092.622 0 1.118-.098.495-.313.962-.588 1.119-.118.038-.41.8-1.176 1.118h-.586l-.588-.56c-.231-.221-.526-.38-.587-.558-.23-.657-.101-1.582 0-2.237.101-.653.436-.824.961-.928zm2.625-6.33 4.88 4.393 1.184-1.314 1.114 4.367-4.46-.652 1.158-1.286-4.88-4.394 1.004-1.115zm-6.16 2.42c.375-.12.776-.157 1.111 0 .337.164.469.287.556.537.108.314-.098.57-.556 1.072l-1.143.369A.4.4 0 0 1 8 6.7V5.64c.228-.19.36-.474.555-.536z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandslide);
export default __webpack_public_path__ + "static/media/landslide.707c025f7e83cb9257d920fdbfdacea0.svg";
export { ForwardRef as ReactComponent };